exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.embed_remember-container_1i83m,\r\n.embed_remember-warning_3gFwI,\r\n.embed_sandboxed_30PXv {\r\n    margin: 8px 0;\r\n}\r\n\r\n.embed_remember-container_1i83m {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.embed_remember-checkbox_1i_XI {\r\n    margin-right: 8px;\r\n}\r\n\r\n.embed_remember-warning_3gFwI {\r\n    padding: 0.5rem;\r\n    border-radius: 0.25rem;\r\n    background-color: rgba(255, 81, 81, 0.25);\r\n    border: 1px solid red;\r\n}", ""]);

// exports
exports.locals = {
	"remember-container": "embed_remember-container_1i83m",
	"rememberContainer": "embed_remember-container_1i83m",
	"remember-warning": "embed_remember-warning_3gFwI",
	"rememberWarning": "embed_remember-warning_3gFwI",
	"sandboxed": "embed_sandboxed_30PXv",
	"remember-checkbox": "embed_remember-checkbox_1i_XI",
	"rememberCheckbox": "embed_remember-checkbox_1i_XI"
};